

















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { nextTick } from "process";
import store from "@/store";

@Component
export default class ConfirmModalComponent extends Vue {
  $refs!: {
    main: HTMLDivElement;
    yesButton: HTMLElement;
    inputEmail: HTMLInputElement;
  };
  @Prop({ default: "" }) inputType!: string;
  @Prop({ default: true }) validateInput!: boolean;
  public title!: string;
  public closeText!: any;
  public showing: boolean = false;
  public value: any = undefined;
  private question!: string;
  private yesTitle: string = "";
  private noTitle: string = "";
  private subtitle: string = "";
  private inputString: string = "";
  mounted() {
    this.title = this.$t("shared.confirm").toString();
    this.closeText = this.$t("shared.close").toString();
    if (this.inputType === "email") {
      this.inputString = store.state.account.user?.email ?? "";
    }
    // this.$refs.yesButton.focus();
  }
  public accept() {
    this.yes();
  }
  public show(
    question: any,
    yesTitle?: string,
    noTitle?: string,
    subtitle?: string
  ) {
    this.question = question;
    this.showing = true;
    if (yesTitle) {
      this.yesTitle = yesTitle;
    }
    if (noTitle) {
      this.noTitle = noTitle;
    }
    if (subtitle) {
      this.subtitle = subtitle;
    }
    window.addEventListener("keyup", this.keyEvent);
    this.$nextTick(() => {
      this.$refs.yesButton.focus();
      if (this.inputType === "email") {
        this.$refs.inputEmail.focus();
        this.$refs.inputEmail.select();
      }
    });
  }
  public yes() {
    if (this.inputType) {
      this.value = this.inputString;
      if (
        this.validateInput &&
        (!this.inputString || this.inputString.trim() === "")
      ) {
        return;
      }
    }
    this.$emit("yes", this.value);
    this.value = undefined;
    this.showing = false;
    window.removeEventListener("keyup", this.keyEvent);
  }
  public no() {
    this.value = undefined;
    this.showing = false;
    this.$emit("no");
    window.removeEventListener("keyup", this.keyEvent);
  }
  keyEvent(event) {
    if (event.ctrlKey && event.keyCode) {
      if (event.keyCode === 13) {
        this.yes();
      }
    }
  }
}
